import apiClient from '@/services/reimburseapiClient'
export default {
    //<!-----------------------------expense page api's-------------------------------->
    getAccounts(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/accounts/' + page + '/' + count + '?search=' + search + '&status=' + status + '&sort=' + sort + '&label=' + label + '&custom=' + custom)
    },
    getAccountsExport(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/accounts/export/' + page + '/' + count + '?search=' + search + '&status=' + status + '&sort=' + sort + '&label=' + label + '&custom=' + custom)
    },

    getAccountDetails(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/accounts/accountsdetails')
    },
    //Status change
    postAccountsstatus(data, token) {
        apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        return apiClient.post("/accounts/statuschange", data);
    },
    /**
     * expense create api
     * @param {*} form 
     */
    postAccount(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/accounts/create', form)
    },
    /**
     * expense delete api
     * @param {*} ids 
     */
    postAccountdelete(ids, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/accounts/bulkdelete', ids)
    },

    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postAccountSingleDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/accounts/singledelete', data)
    },

    /**
     * get expense from particular id
     */
    getAccount(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/accounts/view/' + id)
    },
    /**
     * update api
     * @param {*} form 
     * @param {*} id 
     */
    postAccountUpdate(form, id, token) {

        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/accounts/update/' + id, form)
    },
    postFiltercreateAccount(data, token) {

        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('expense/filtercreate', data)
    },
    /**
     * 
     * @param {*} data 
     * @param {*} id 
     */
    postFilterudpateAccount(data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/accounts/filterupdate/' + id, data)
    },
    /**
     * 
     * @param {*} data 
     */
    postFilterdeleteAccount(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/accounts/filterbulkdelete', data)
    },
    /**
     * filter list api
     * @param {*} id 
     */
    getAccountFilter(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/accounts/filterview/' + id)
    },
    postTag(tag_name, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/accounts/TagCreate', tag_name)
    },
    gettaglist(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/accounts/taglist')
    }
}